export default "__VITE_ASSET__2b4d7694__"